import { render, staticRenderFns } from "./ProjectProductsV3List.vue?vue&type=template&id=b66ede0e&scoped=true"
import script from "./ProjectProductsV3List.vue?vue&type=script&lang=js"
export * from "./ProjectProductsV3List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ede0e",
  null
  
)

export default component.exports